module.exports = __webpack_public_path__ + "img/transparencyoptions_72ppi.54105d1a.png";